import {Point} from '@yandex-taxi/js-integration-api'
import {debounce} from 'lodash'

export const getGeolocationFromBrowser = debounce((cb: (coords?: Point) => void) => {
  if (!navigator.geolocation) {
    return cb()
  }
  navigator.geolocation.getCurrentPosition(
    ({coords}) => cb([coords.longitude, coords.latitude]),
    () => cb(),
    {enableHighAccuracy: true},
  )
}, 500)
